import { useSelectorKiosk } from "./useSelectorKiosk";

const usePrinter = () => {
    const selector = useSelectorKiosk(state => state.printer);
    return selector;
}

export default usePrinter;